import { render, staticRenderFns } from "./AllCommissions.vue?vue&type=template&id=09cc625a&scoped=true&"
import script from "./AllCommissions.vue?vue&type=script&lang=ts&"
export * from "./AllCommissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cc625a",
  null
  
)

export default component.exports